import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule, MatCheckboxModule, MatDatepickerModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatNativeDateModule, MatPaginatorModule, MatSelectModule, MatTooltipModule } from '@angular/material';
import { NgxLoadingModule } from 'ngx-loading';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card'
import { CadastrarMensagemModuloComponent } from './cadastrar-mensagem-modulo.component';
import { SharedModule } from 'app/main/content/shared/shared.module';


const routes = [
    {
      path: 'mensagemModulo',
      component: CadastrarMensagemModuloComponent
    }
  ];

@NgModule({
  declarations: [CadastrarMensagemModuloComponent],
  imports: [
    CommonModule,
    FuseSharedModule,
    RouterModule.forChild(routes),
    SharedModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatNativeDateModule,
    MatDialogModule,
    MatTooltipModule,
    HttpClientModule,
    NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
    MatCardModule,
    MatDialogModule
    
  ],
  exports: [CadastrarMensagemModuloComponent]
})
export class CadastrarMensagemModuloModule { }
